import React from 'react'
import AdvancedTable from '../../Components/AdvancedTable'
import Pagination from 'react-js-pagination'

class AttractionList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 1
    }
  }

  _smartButton = (id, title, is_disabled) => (
    <button
      onClick={() => this.props.arrayAdd(id, title, is_disabled)}
      className='btn btn-primary'
    >
      <i className='fa fa-arrow-down' />
    </button>
  )

  _simpleBoolView = (bool) => {
    return (
      <span className={`badge badge-${bool ? 'danger' : 'success'}`}>{bool ? 'Disabled' : 'Enabled'}</span>
    )
  }

  _changePage = (page) => {
    this.setState({ page })
    this.props.changePage(page)
  }

  render () {
    const { data, meta } = this.props
    return (
      <section className='section mt-3 mb-3'>
        <div className='title-block'>
          <h1 className='title'>Attractions List</h1>
        </div>
        <div className='modal-content'>
          <AdvancedTable
            className='table-bordered'
            colSpan={4}
            header={[
              { field: 'ID' },
              { field: 'Title' },
              { field: 'Status' },
              { field: 'Select' }
            ]}
            body={
              data &&
                data.list_ids.length > 0 &&
                data.list_ids.map((x, i) => ([
                  { field: x.id },
                  { field: x.title },
                  { field: this._simpleBoolView(x.is_disabled) },
                  { field: this._smartButton(x.id, x.title, x.is_disabled) }
                ]))
            }
          />
        </div>
        <section className='section text-center mt-3'>
          {
            (meta && meta.item_total > 10) &&
              <Pagination
                innerClass='pagination'
                itemClass='page-item'
                linkClass='page-link'
                activePage={this.state.page}
                itemsCountPerPage={meta.item_limit}
                totalItemsCount={meta.item_total}
                pageRangeDisplayed={5}
                onChange={this._changePage}
              />
          }
        </section>
      </section>
    )
  }
}

export default AttractionList



// WEBPACK FOOTER //
// ./src/Containers/CronReport/AttractionList.js